<template>
  <div class="wan-resources-upload-wrap">
    <!-- *成员分类 -->
    <div class="wan-resources-upload-content">
      <div class="title-wrap">
        <div class="title">*成员分类</div>
      </div>

      <el-row :gutter="10">
        <el-col :span="8">
          <el-select
            v-model="ruleForm.postId"
            clearable
            placeholder="选择岗位"
            style="width: 100%"
            @change="changeProvince('postId')"
          >
            <el-option
              v-for="item in postList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-select
            v-model="ruleForm.education"
            clearable
            placeholder="选择学历"
            style="width: 100%"
            @change="changeProvince('education')"
          >
            <el-option
              v-for="item in industryList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-select
            v-model="ruleForm.braid"
            clearable
            placeholder="选择编制"
            style="width: 100%"
            @change="changeProvince('braid')"
          >
            <el-option
              v-for="item in customTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>

      <el-row :gutter="10" style="margin-top: 20px">
        <el-col :span="20">
          <el-input
            v-model="ruleForm.searchValue"
            placeholder=""
            style="width: 100%"
            @keyup.enter.native="getList"
          >
          </el-input>
        </el-col>
        <el-col :span="4">
          <div class="search-btn" @click="getList">搜索</div>
        </el-col>
      </el-row>
    </div>

    <!-- 搜索结果 -->
    <div style="margin: 20px 0 15px">{{ total }}个搜索结果</div>

    <div class="el-list">
      <el-checkbox-group v-model="checkedList">
        <div
          v-for="(item, index) in list"
          :key="index"
          :style="{
            background: checkedList.includes(item.id) ? '#f1f5f8' : '#fcfdfe',
          }"
          class="el-list-item"
          @click="changeList(item, index)"
        >
          <img :src="item.headerUrl" alt="" />
          <div class="content">
            <div class="top">{{ item.name }} | {{ item.postName }}</div>
            <div class="bottom">
              编制：{{ item.braidName }} &nbsp;&nbsp;&nbsp; 学历：{{
                item.educationName
              }}
            </div>
          </div>
          <el-checkbox :label="item.id" />
        </div>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "pickMember",

  props: {
    parentCheckedList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      ruleForm: {},

      // 学历
      industryList: [],

      // 编制
      customTypeList: [],

      // 岗位
      postList: [],
      checkedList: [],
      list: [],
      total: 0,
    };
  },

  async created() {
    // 学历
    this.industryList = [...(await this.$utils.getClassSetList(5))];
    // 编制
    this.customTypeList = [...(await this.$utils.getClassSetList(10))];
    // 岗位
    this.postList = [...(await this.$utils.getPostList())];

    await this.getList();
  },

  methods: {
    changeProvince(type) {
      console.log(type, "type");
      this.getList();
    },

    getList() {
      this.$http
        .getMemberList({
          pageIndex: 1,
          pageSize: 9999,
          condition: {
            ...this.ruleForm,
            spaceId: this.$store.state.userInfo.id,
            // postId: "",
            // braid: "",
            // education: "",
            state: "S",
            name: this.ruleForm.searchValue,
          },
        })
        .then(({ data }) => {
          console.log(data);
          this.list = data.result;
          this.checkedList = this.parentCheckedList.map((item) => item.id);
          this.total = data.total;
        });
    },

    changeList(item, index) {
      console.log(item, index);
      if (this.checkedList.includes(item.id)) {
        this.checkedList.splice(this.checkedList.indexOf(item.id), 1);
      } else {
        this.checkedList.push(item.id);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.search-btn {
  width: 100px;
  height: 40px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  line-height: 40px;
  text-align: center;
}

.el-list {
  .el-list-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    background: #fcfdfe;
    padding-right: 20px;
    box-sizing: border-box;

    img {
      width: 64px;
      height: 64px;
      flex: 0 0 64px;
      border-radius: 50%;
    }

    .content {
      flex: 1;
      margin-left: 12px;
      font-size: 16px;

      .top {
        margin: 7px 0;
      }

      .bottom {
        color: #7a7b7c;
      }
    }
  }

  /deep/ .el-checkbox {
    .el-checkbox__label {
      display: none;
    }

    .el-checkbox__inner {
      border-radius: 50%;
    }
  }
}
</style>
